import { Box } from "@mui/material";
import DocumentFiles from "components/documents/DocumentFiles";
import CreateDocumentForm from "components/documents/ValidationModal/CreateDocumentForm";

type Props = {
  tempWorker: any;
  document: any;
  kind: string;
  label: string;
}

const DocumentForm = ({ tempWorker, document, kind, label }: Props) => {
  return (
    <Box>
      {document ? (
        <DocumentFiles document={document} tempWorkerId={tempWorker.id} label={label} kind={kind} />
      ) : (
        <CreateDocumentForm tempWorkerId={tempWorker.id} kind={kind} label={label} />
      )}
    </Box>
  );
};

export default DocumentForm;